import React, { useState, useEffect } from 'react';
import { addSurveyHeader, updateSurveyHeader } from "../apicalls/surveyHeaders";

import { isAuthenticated } from '../apicalls/auth';
function SurveyHeaderForm({ header, onSave, onCancel }) {
    const [surveyName, setSurveyName] = useState('');
    const [instructions, setInstructions] = useState('');
    const [organizationId, setOrganizationId] = useState('');
    const user = isAuthenticated();
    useEffect(() => {
        if (header) {
            setSurveyName(header.survey_name);
            setInstructions(header.instructions);
            setOrganizationId(header.organization_id);
        } else {
            setSurveyName('');
            setInstructions('');
            setOrganizationId('');
        }
    }, [header]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const headerDetails = {
            survey_name: surveyName,
            instructions,
            organization_id: organizationId
        };

        if (header) {
            await updateSurveyHeader(header.id, headerDetails,user.access_token);
        } else {
            await addSurveyHeader(headerDetails,user.access_token);
        }
        onSave();
    };

    return (
        <div className="popup">
            <div className="popup-inner">
                <button className="close-btn" onClick={onCancel}>X</button>
                <h1>{header ? "Edit" : "Add"} Survey Header</h1>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Survey Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={surveyName}
                            onChange={(e) => setSurveyName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Instructions:</label>
                        <textarea
                            className="form-control"
                            value={instructions}
                            onChange={(e) => setInstructions(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Organization ID:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={organizationId}
                            onChange={(e) => setOrganizationId(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary">Save Header</button>
                        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SurveyHeaderForm;
